export default {
  root: {
    padding: '12px 20px',
    '@media (max-width:599.95px)': {
      padding: '12px 16px'
    }
  }
};
